import React, { useState, useEffect, useRef } from 'react'
import { Panel, Row, Table, Progress, Icon, List, FlexboxGrid, Rate } from 'rsuite'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { v4 as uuidv4, validate } from 'uuid'
import moment from 'moment'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'
import notification from '../../utils/notification'
import { isRequired } from '../../utils/ValidatorUtils'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { saveAssessmentForm } from '../../redux/actions/assessment'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_DRAFT_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import EditButton from '../../components/buttons/editButton/EditButton'
import { getValueFromOptions } from '../../utils/dataUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import { isEmpty } from 'lodash-es'
import {
  buildFilteredTree,
  getLabelsWithParents,
  locationZipcode,
} from '../../components/location/Location'
import RenderLocationTree from '../assessment/RenderLocationTree'
import AppContext from '../../context/AppContext'

export default function EvaluationViewClosureWidget({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { Line } = Progress

  const [formSchema, setFormSchema] = useState(schema)
  const [location, setLocation] = useState([])

  const contextValue = React.useContext(AppContext)

  useEffect(() => {
    setFormSchema(schema)
    handleLocation()
  }, [schema])

  const handleLocation = async () => {
    let locationJson = await locationZipcode()

    setLocation(locationJson || [])
  }

  // const renderAnswer = (rowData) => {
  //   if (rowData) {
  //     var ans
  //     switch (rowData.questionType) {
  //       case 1:
  //         ans = rowData.radioAndCheckBoxOptions.map((item) => {
  //           return (
  //             <p>
  //               {rowData.optionsIdAnswer?.includes(item.value) ? (
  //                 <Icon icon="check-circle" />
  //               ) : (
  //                 <Icon icon="circle-o" />
  //               )}{' '}
  //               {item.label}
  //             </p>
  //           )
  //         })
  //         break
  //       case 2:
  //         ans = rowData.radioAndCheckBoxOptions.map((item) => {
  //           return (
  //             <p>
  //               {rowData.optionsIdAnswer?.includes(item.value) ? (
  //                 <Icon icon="check-square-o" />
  //               ) : (
  //                 <Icon icon="square-o" />
  //               )}{' '}
  //               {item.label}
  //             </p>
  //           )
  //         })
  //         break
  //       case 3:
  //         ans = rowData.textAnswer
  //         break
  //       case 4:
  //         ans = rowData.textAnswer
  //         break
  //       case 5:
  //         ans = budgetFormat(rowData.numberAnswer)
  //         break
  //       case 6:
  //         ans = (
  //           <Rate
  //             defaultValue={rowData.ratingAnswer || 0}
  //             max={10}
  //             classPrefix="rs-rate rs-rate-size-md"
  //             disabled={true}
  //           />
  //         )
  //         break
  //       case 7:
  //         ans = !isEmpty(rowData?.areaAnswer) && (
  //           <ul>
  //             {getLabelsWithParents(location, rowData.areaAnswer)?.map((e) => {
  //               return <li key={e}>{e}</li>
  //             })}
  //           </ul>
  //         )
  //         break
  //       case 8:
  //         ans = !isEmpty(rowData?.areaAnswer) && (
  //           <Row>
  //             <RenderLocationTree data={buildFilteredTree(location, rowData.areaAnswer)} />
  //           </Row>
  //         )
  //         break
  //       case 9:
  //         ans = rowData.optionLabel
  //         break
  //       default:
  //         return null
  //     }

  //     return ans
  //   }
  //   return null
  // }

  const renderAnswer = (item, type) => {
    let answer = type == 1 ? item.coworkerAnswer : item.coordinatorAnswer

    if (item.questionType == 7) {
      return !isEmpty(answer) ? (
        <ul>
          {getLabelsWithParents(location, [answer])?.map((e) => {
            return <li key={e}>{e}</li>
          })}
        </ul>
      ) : null
    }

    if (item.questionType == 8) {
      return !isEmpty(answer) ? (
        <Row>
          <RenderLocationTree data={buildFilteredTree(location, answer?.split('|'))} />
        </Row>
      ) : null
    }

    return answer
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={<span>{formSchema?.header || ''}</span>}
        bordered
      >
        <Row>โครงการ : {formSchema.projectName}</Row>

        <Row>รหัสโครงการ : {formSchema.projectCode}</Row>

        <Row>ระยะเวลาดำเนินการ : {formSchema.period}</Row>

        <br />

        {formSchema?.statistics?.length > 0 && (
          <>
            <p>1. ภาพรวมความเข้มแข็งภาคี 3 มิติ</p>
            <div
              className="line-vertical-wrapper"
              style={{ height: 200, justifySelf: 'anchor-center' }}
            >
              {formSchema.statistics.map((item) => {
                return (
                  <Row style={{ marginRight: formSchema.marginRight || 10 }}>
                    <Line
                      vertical
                      percent={item.percentage}
                      strokeColor={item.color}
                      strokeWidth={formSchema.barWidth || 100}
                    />
                    <p style={{ textAlign: 'center' }}>{item.name}</p>
                    <p style={{ textAlign: 'center' }}>{item.name2}</p>
                    <p style={{ textAlign: 'center' }}>{item.name3}</p>
                  </Row>
                )
              })}
            </div>
          </>
        )}

        <br />

        {formSchema?.statistics?.length > 0 && <p>2. ผลการประเมินด้านการบริหารโครงการ</p>}

        <br />

        {/* <Panel collapsible defaultExpanded header={' '} bordered bodyFill> */}
        <List hover >
          <List.Item
            style={{ backgroundColor: contextValue.theme[0] == 'dark' ? '#353740' : '#f2f1f1' }}
          >
            <FlexboxGrid>
              {/* <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center'}}>
                <b>ลำดับ</b>
              </FlexboxGrid.Item> */}

              <FlexboxGrid.Item colspan={8}>
                <b>คำถาม</b>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item colspan={7} style={{ paddingLeft: 15}}>
                <b>ภาคีประเมินตนเอง</b>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item colspan={7} style={{ paddingLeft: 15}}>
                <b>นักวิชาการประเมินภาคี</b>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </List.Item>
          {formSchema?.questionAnswerValues?.map((item, index) => (
            <List.Item key={item.id} index={index}>
              <FlexboxGrid>
                {/* <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center'}}>
                  {index + 1}
                </FlexboxGrid.Item> */}

                <FlexboxGrid.Item colspan={8}>{item.questionName}</FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={7} style={{ paddingLeft: 15}}>{renderAnswer(item, 1)}</FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={7} style={{ paddingLeft: 15}}>{renderAnswer(item, 2)}</FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
          ))}
        </List>
        {/* </Panel> */}

        {/* <Panel collapsible defaultExpanded header={'ภาคีประเมินตนเอง'} bordered bodyFill>
          <List hover>
            <List.Item
              style={{ backgroundColor: contextValue.theme[0] == 'dark' ? '#353740' : '#f2f1f1' }}
            >
              <FlexboxGrid>
                <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center' }}>
                  <b>ลำดับ</b>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={11}>
                  <b>คำถาม</b>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={11}>
                  <b>ภาคีประเมินตนเอง</b>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
            {formSchema?.coworkerValues?.map((item, index) => (
              <List.Item key={item.id} index={index}>
                <FlexboxGrid>
                  <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center' }}>
                    {index + 1}
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={11}>{item.questionName}</FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={11}>{renderAnswer(item)}</FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            ))}
          </List>
        </Panel>

        <br />
        <Panel collapsible defaultExpanded header={'นักวิชาการประเมินภาคี'} bordered bodyFill>
          <List hover>
            <List.Item
              style={{ backgroundColor: contextValue.theme[0] == 'dark' ? '#353740' : '#f2f1f1' }}
            >
              <FlexboxGrid>
                <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center' }}>
                  <b>ลำดับ</b>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={11}>
                  <b>คำถาม</b>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={11}>
                  <b>นักวิชาการประเมินภาคี</b>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
            {formSchema?.coordinatorValues?.map((item, index) => (
              <List.Item key={item.id} index={index}>
                <FlexboxGrid>
                  <FlexboxGrid.Item colspan={2} style={{ textAlign: 'center' }}>
                    {index + 1}
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={11}>{item.questionName}</FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={11}>{renderAnswer(item)}</FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            ))}
          </List>
        </Panel> */}

        <br />
        <br />
        <br />

        <span>
          หมายเหตุ : สามารถดูรายละเอียดเพิ่มเติมได้ที่{' '}
          <a href={schema.link} target="_blank">
            {schema.linkLabel}
          </a>
        </span>
      </Panel>
    </>
  )
}
